/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInstitutionConfigDtoApiResponse } from '../../models/amoxcalli-institution-config-dto-api-response';

export interface ApiInstitutionConfigScheduleDelete$Plain$Params {
  institutionId?: string;
}

export function apiInstitutionConfigScheduleDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiInstitutionConfigScheduleDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionConfigScheduleDelete$Plain.PATH, 'delete');
  if (params) {
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>;
    })
  );
}

apiInstitutionConfigScheduleDelete$Plain.PATH = '/api/institution-config/schedule';
